// extracted by mini-css-extract-plugin
export default {"container":"Messages_container__8fVJm","containerNotFound":"Messages_containerNotFound__aD4Ku","notfound":"Messages_notfound__VVhme"};